// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */

body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  background-color: #e4e4e4 !important;
  background-size: cover;
}

.app {
  display: flex;
  height: 100%;
}

.main-content {
  flex: 1 1;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAIlB;EACE,SAAS;EACT,kCAAkC;EAClC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,cAAc;AAChB","sourcesContent":["/* Global Styles */\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');\n\nbody {\n  margin: 0;\n  font-family: 'Poppins', sans-serif;\n  background-color: #e4e4e4 !important;\n  background-size: cover;\n}\n\n.app {\n  display: flex;\n  height: 100%;\n}\n\n.main-content {\n  flex: 1;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
